
import Header from '../../components/feature/Header';
import Footer from '../../components/feature/Footer';
import ServicesHero from './components/ServicesHero';
import ServicesDetail from './components/ServicesDetail';
import ServicesProcess from './components/ServicesProcess';
import ServicesCTA from './components/ServicesCTA';

export default function Services() {
  return (
    <div className="min-h-screen">
      <Header />
      <main>
        <ServicesHero />
        <ServicesDetail />
        <ServicesProcess />
        <ServicesCTA />
      </main>
      <Footer />
    </div>
  );
}
